// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AYjGA","colBig":"styles_colBig__3nbld","colSmall":"styles_colSmall__1ptj5"};